import React from 'react';

export const TeamsSectionContext = React.createContext({});
export const TeamsSectionProvider = TeamsSectionContext.Provider;
